<ng-container *ngIf="product && product.productPaths.length > 0">
  <div class="row mb-2">
    <div class="col-12">
      <h2>{{ 'commercialCommon.solutionDownload.downloadAndInstall' | transloco: { productName: product.productLocalization.productName } }}</h2>
    </div>
  </div>
  <div class="col-12 mb-2">
    <yat-download-button-group id="2550c9d4-815e-4284-84af-ee71fe6c8576" [productPaths]="product.productPaths" [productName]="product.productLocalization.productName"> </yat-download-button-group>
  </div>
  <div class="row mb-4">
    <div class="col-12">
      <p class="font-small c-gray terms">
        <transloco
          id="96dc472d-7309-441a-8d3c-938277b7e727"
          key="commercialCommon.solutionDownload.forMoreInformation"
          [params]="{
            downloadOverviewLink: { url: getDownloadOverviewPath(), class: 'c-gray underline', target: '_blank', id: 'a5933f86-ed7a-452d-9dc6-a911c9731de7' }
          }"></transloco>
      </p>
    </div>
  </div>
</ng-container>
